import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModalsComponentsModule } from './components';
import { ModalsTypesModule } from './modalsTypes';
import { ModalsViewsModule } from './modalsViews';

import { ModalsComponent } from './modals.shared.component';

@NgModule({
    declarations: [
        ModalsComponent
    ],
    imports: [
        CommonModule,
        ModalsComponentsModule,
        ModalsTypesModule,
        ModalsViewsModule,
    ],
    exports: [
        ModalsComponent,
        ModalsComponentsModule,
        ModalsTypesModule,
        ModalsViewsModule,
    ],
})
export class ModalsModule {
    public static entry = ModalsComponent;
}
